import Vue from 'vue';
import DOMPurify from 'dompurify';

export default class ListUtils {
  static loadItemsData (instance, endpoint, listField, params) {
    instance.$http.post(endpoint, params).then(response => {
      instance[listField] = response.data.data;
      instance.loaded = true;

      if (params.successAction) {
        params.successAction(response);
      }
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
    });
  }

  static loadPaginatedItemsData (instance, config) {
    instance.loaded = false;
    instance.loadError = false;

    instance.$http.post(config.endpoint, config.params).then(response => {
      instance[config.listField] = response.data.data;
      instance.paginationMetaData = response.data.meta || null;
      instance.loaded = true;
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
    });
  }

  static removeItem (config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: config.buttonConfirmText || 'Yes, remove',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        let url = config.endpointBase;

        if (config.id) {
          url = config.endpointBase + config.id;
        }

        let params = {};

        if (!config.id && config.idKey) {
          params[config.idKey] = config.idValue;
        }

        if (config.params) {
          params = config.params;
        }

        config.$http.post(url, params).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: DOMPurify.sanitize(config.successText),
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true,
              timer: typeof config.timer === 'number' ? config.timer : false,
              timerProgressBar: !!config.timer
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              if (config.errorAction) {
                config.errorAction();
              }

              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: DOMPurify.sanitize(config.errorText),
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true,
              timer: typeof config.timer === 'number' ? config.timer : false,
              timerProgressBar: !!config.timer
            });

            if (config.errorAction) {
              config.errorAction();
            }
          }
        }).catch(error => {
          if (config.errorAction) {
            config.errorAction();
          }

          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: DOMPurify.sanitize(config.errorText),
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: typeof config.timer === 'number' ? config.timer : false,
            timerProgressBar: !!config.timer
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }

  static modifyItem (config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: config.buttonConfirmText || 'Yes',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        let url = config.endpointBase;

        if (config.id) {
          url = config.endpointBase + config.id;
        }

        let params = {};

        if (config.params) {
          params = config.params;
        }

        config.$http.post(url, params).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: DOMPurify.sanitize(config.successText),
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true,
              timer: 1000,
              timerProgressBar: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              if (config.errorAction) {
                config.errorAction();
              }

              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: DOMPurify.sanitize(config.errorText),
              icon: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });

            if (config.errorAction) {
              config.errorAction();
            }
          }
        }).catch(error => {
          if (config.errorAction) {
            config.errorAction();
          }

          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: DOMPurify.sanitize(config.errorText),
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }

  static getKeyLabel (keys, label) {
    return keys[label];
  }
}
